"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._JSONOutput = {
    type: "structure",
    required: [],
    members: {
        RecordDelimiter: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_JSONOutput.js.map